import * as Actions from 'store/actions/app/shipping_guides.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'

const initialState = {
  loading_drivers: false,
  drivers: [],

  loading_shipping_guides: false,
  shipping_guides: [],
  total_shipping_guides: 0,

  saving_shipping_guide: false,
  saved_shipping_guide: false,
}

const shippingGuidesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DRIVERS: {
      return {
        ...state,
        loading_drivers: action.payload.loading,
        drivers: action.payload.data ?? state.drivers,
      }
    }
    case Actions.GET_SHIPPING_GUIDES: {
      return {
        ...state,
        loading_shipping_guides: action.payload.loading ?? state.loading_shipping_guides,
        shipping_guides: action.payload.items ?? state.shipping_guides,
        total_shipping_guides: action.payload.total ?? state.total_shipping_guides,
      }
    }
    case Actions.SAVE_SHIPPING_GUIDE: {
      return {
        ...state,
        saving_shipping_guide: action.payload.saving ?? state.saving_shipping_guide,
        saved_shipping_guide: action.payload.saved ?? false,
        shipping_guides: action.payload.data
          ? addOrUpdateObjectInArray(state.shipping_guides, action.payload.data, 'idguia', true)
          : state.shipping_guides,
      }
    }
    default: {
      return state
    }
  }
}

export default shippingGuidesReducer
